import { DetentionSortOption } from '@rematter/frontend-lib-api-client';

import { DetentionRecord } from '~/modules/transportation/types';
import { createQueryHook } from '~/shared/providers/api';
import {
  parseCalendarDate,
  parseCalendarDateOrNull,
  parseZonedDateTime,
} from '~/shared/utils/dateTime';

export interface DetentionsFilter {
  ids?: string[];
  carrierId?: string;
  locationId?: string;
}

interface GetDetentionsVariables {
  filter?: DetentionsFilter;
  sorting?: DetentionSortOption[];
  pagination?: {
    offset: number;
    limit: number;
  };
}

export const useDetentionsListQuery = createQueryHook(
  'transportation.detentionsList',
  (variables: GetDetentionsVariables) => ({
    detentions: {
      __args: {
        filter: variables.filter,
        pagination: variables.pagination,
        sorting: variables.sorting ?? ['StartDateDesc'],
      },
      page: {
        total: true,
      },
      entries: {
        id: true,
        carrierId: true,
        carrier: {
          id: true,
          name: true,
        },
        locationId: true,
        location: {
          id: true,
          facilityName: true,
        },
        startDate: true,
        endDate: true,
        freeMinutes: true,
        ratePerMinute: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: (data): { detentions: DetentionRecord[]; total: number } => ({
      detentions: (data?.detentions?.entries ?? []).map((detention) => ({
        id: detention.id,
        carrierId: detention.carrierId,
        carrierName: detention.carrier?.name ?? undefined,
        locationId: detention.locationId,
        locationName: detention.location?.facilityName ?? undefined,
        startDate: parseCalendarDate(detention.startDate),
        endDate: parseCalendarDateOrNull(detention.endDate) ?? undefined,
        freeMinutes: detention.freeMinutes,
        ratePerMinute: detention.ratePerMinute,
        timestamps: {
          createdAt: parseZonedDateTime(detention.timestamps.createdAt),
          updatedAt: parseZonedDateTime(detention.timestamps.updatedAt),
        },
      })),
      total: data?.detentions?.page?.total ?? 0,
    }),
  },
);
